import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinambegaonpune() {



  const cardData =
  {
    keyword: 'Bus On Rent in Ambegaon Pune',
    heading: 'Sanavi Travels: Bus On Rent in Ambegaon Pune',
    headingDescription: 'Bus On Rent in Ambegaon Pune provides dependable, comfortable, and affordable bus rental services for local trips, outstation journeys, corporate travel, weddings, picnics, school trips, and group tours. With a fleet of AC and Non-AC buses, mini buses, and luxury coaches ranging from 17 to 50 seaters, we ensure safe and smooth travel with well-maintained vehicles and professional drivers. Offering flexible rental packages, transparent pricing, on-time service, and 24/7 booking support, bus rental services in Ambegaon Pune are ideal for hassle-free group transportation across Pune, Mumbai, Konkan, Shirdi, Mahabaleshwar, and other destinations.',

    top: 'Top Places to Visit in Ambegaon with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ambegaon Taluka",
    "description": "Ambegaon is a picturesque taluka in Pune district, located in the northern part of the Sahyadri ranges. Known for its rugged hills, dense forests, ancient caves, and historical forts, Ambegaon holds immense archaeological and cultural significance. The region is especially famous for its connection to Maratha history and ancient Buddhist heritage, making it a unique blend of nature, spirituality, and history."
  },
  {
    "title": "Bhimashankar Temple",
    "description": "Bhimashankar Temple is one of the 12 Jyotirlingas of Lord Shiva and the most sacred site in Ambegaon taluka. Nestled amidst dense forests of the Western Ghats, the temple is both a major pilgrimage destination and a biodiversity hotspot. Devotees and tourists visit throughout the year to experience spiritual peace, misty weather, and scenic forest surroundings."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Surrounding the temple, Bhimashankar Wildlife Sanctuary is a protected forest area known for its rich biodiversity. It is home to the Indian giant squirrel (Shekru), numerous bird species, medicinal plants, and dense evergreen forests. Nature trails and eco-tourism activities attract wildlife lovers and researchers."
  },
  {
    "title": "Manchar Town",
    "description": "Manchar is the main town and commercial center of Ambegaon taluka. It serves as a base for travelers visiting Bhimashankar and nearby forts. The town offers local markets, accommodation, and a glimpse into rural Maharashtrian lifestyle."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat is a scenic mountain pass near Ambegaon that connects the Deccan plateau to the Konkan region. Known for its breathtaking valley views, waterfalls, and winding roads, the ghat is especially beautiful during the monsoon season."
  },
  {
    "title": "Kailasgad Fort",
    "description": "Kailasgad Fort is a lesser-known hill fort in Ambegaon taluka, offering a peaceful trekking experience. The fort provides panoramic views of the surrounding hills and valleys and is ideal for trekkers seeking solitude and untouched landscapes."
  },
  {
    "title": "Shrivardhan and Manaranjan Forts (Rajmachi Nearby)",
    "description": "Located close to Ambegaon, these twin forts of Rajmachi are historically significant Maratha strongholds. Surrounded by dense forests and valleys, they are popular for trekking, camping, and experiencing monsoon beauty."
  },
  {
    "title": "Ancient Rock-Cut Caves",
    "description": "Ambegaon taluka is dotted with several ancient Buddhist rock-cut caves, reflecting the region’s importance as a spiritual and trade center in ancient times. These caves offer insight into early Indian architecture and monastic life."
  },
  {
    "title": "Village Life and Rural Tourism",
    "description": "The villages of Ambegaon offer authentic rural experiences, with farming activities, traditional cuisine, and local festivals. Visitors can engage with local communities and enjoy the peaceful countryside atmosphere."
  },
  {
    "title": "Monsoon Waterfalls and Nature Trails",
    "description": "During the monsoon, Ambegaon transforms into a lush green paradise with numerous seasonal waterfalls, misty forests, and scenic trekking routes. These natural attractions make it a favorite destination for nature lovers and photographers."
  }
]
,



"services": [
{
"name": "Bus On Rent in Ambegaon Pune",
"description": "Bus On Rent in Ambegaon Pune offers reliable and comfortable buses for local and outstation travel. Ideal for families, tourists, corporate groups, and special events, these buses feature spacious seating, modern amenities, and professional drivers. With flexible scheduling and well-maintained vehicles, it ensures smooth, safe, and hassle-free journeys for weddings, sightseeing trips, corporate events, and group outings in and around Ambegaon Pune."
},
{
"name": "Bus Hire Ambegaon",
"description": "Bus Hire Ambegaon provides customized and convenient bus rental services for weddings, corporate trips, group tours, and long-distance travel. Equipped with modern buses, experienced drivers, and flexible itineraries, it ensures comfortable, safe, and stress-free travel experiences for passengers traveling to or from Ambegaon Pune and nearby areas."
},
{
"name": "AC Bus Ambegaon",
"description": "AC Bus Ambegaon offers fully air-conditioned buses for a refreshing and comfortable travel experience. Perfect for long-distance journeys, family outings, corporate trips, and tourist excursions, these buses provide smooth rides, spacious interiors, and professional drivers, ensuring a pleasant and relaxing travel experience across Ambegaon and surrounding areas."
},
{
"name": "Luxury Bus Ambegaon",
"description": "Luxury Bus Ambegaon delivers premium buses with comfortable seating, elegant interiors, and modern amenities. Suitable for VIP travelers, corporate groups, weddings, and special events, these buses combine style, comfort, and safety to provide a luxurious travel experience for passengers exploring Ambegaon Pune and nearby regions."
},
{
"name": "Wedding Bus Ambegaon",
"description": "Wedding Bus Ambegaon specializes in providing spacious and comfortable buses for weddings, family events, and group transportation. With experienced drivers, timely service, and well-maintained vehicles, it ensures safe, smooth, and memorable travel for all wedding attendees traveling to and from Ambegaon Pune."
},
{
"name": "Corporate Bus Ambegaon",
"description": "Corporate Bus Ambegaon offers professional transportation solutions for office teams, corporate events, and business travel. Featuring modern buses, punctual service, and courteous drivers, it provides safe, reliable, and efficient transport for companies traveling within Ambegaon Pune and nearby areas."
},
{
"name": "Outstation Bus Ambegaon",
"description": "Outstation Bus Ambegaon provides safe and comfortable buses for long-distance travel to nearby cities, tourist destinations, and weekend getaways. Perfect for families, friends, and corporate travelers, these buses offer spacious seating, professional drivers, and flexible schedules for convenient and enjoyable journeys from Ambegaon Pune."
},
{
"name": "Affordable Bus Ambegaon",
"description": "Affordable Bus Ambegaon combines budget-friendly pricing with reliable and comfortable bus services. Ideal for families, groups, and tourists, it provides spacious seating, professional drivers, and timely service without compromising on safety or convenience for travel within Ambegaon Pune and surrounding regions."
},
{
"name": "Chauffeur Driven Bus Ambegaon",
"description": "Chauffeur Driven Bus Ambegaon provides professional drivers who handle navigation, traffic, and scheduling, allowing passengers to enjoy a stress-free travel experience. Suitable for group travel, corporate outings, weddings, and tourist trips, it ensures smooth, safe, and comfortable journeys in Ambegaon Pune and nearby areas."
},
{
"name": "Best Bus Service Ambegaon",
"description": "Best Bus Service Ambegaon is known for punctuality, well-maintained vehicles, and exceptional customer support. Catering to families, tourists, corporate clients, and group travelers, it provides safe, reliable, and comfortable transportation for weddings, events, outings, and long-distance journeys from Ambegaon Pune."
},
{
"name": "Tourist Bus Ambegaon",
"description": "Tourist Bus Ambegaon caters to travelers exploring Ambegaon and nearby attractions. With organized itineraries, experienced drivers, and comfortable buses, it provides hassle-free sightseeing experiences, allowing tourists to enjoy historical, cultural, and scenic destinations without worrying about transportation logistics."
},
{
"name": "Group Travel Bus Ambegaon",
"description": "Group Travel Bus Ambegaon specializes in transporting friends, families, corporate teams, and social groups efficiently and comfortably. With spacious buses, professional drivers, and organized travel plans, it ensures coordinated, enjoyable, and safe group trips in and around Ambegaon Pune."
},
{
"name": "Online Bus Booking Ambegaon",
"description": "Online Bus Booking Ambegaon allows passengers to reserve buses quickly and conveniently with instant confirmation. Offering multiple bus options, transparent pricing, and flexible schedules, it simplifies travel planning for families, tourists, corporate clients, and local commuters traveling to or from Ambegaon Pune."
},
{
"name": "Event Bus Ambegaon",
"description": "Event Bus Ambegaon provides dedicated buses for weddings, corporate events, parties, and other special occasions. With professional drivers, spacious vehicles, and reliable service, it ensures organized, safe, and comfortable transportation for all attendees in Ambegaon Pune and surrounding areas."
},
{
"name": "Ambegaon Travel Bus",
"description": "Ambegaon Travel Bus offers complete bus rental solutions for sightseeing trips, corporate travel, weddings, and outstation journeys. Combining safety, comfort, affordability, and professional service, it caters to families, tourists, and corporate clients seeking convenient and dependable transportation in Ambegaon Pune and nearby regions."
}
],
"tableData": [
["Bus On Rent in Ambegaon Pune", "Bus Hire Ambegaon"],
["AC Bus Ambegaon", "Luxury Bus Ambegaon"],
["Wedding Bus Ambegaon", "Corporate Bus Ambegaon"],
["Outstation Bus Ambegaon", "Affordable Bus Ambegaon"],
["Chauffeur Driven Bus Ambegaon", "Best Bus Service Ambegaon"],
["Tourist Bus Ambegaon", "Group Travel Bus Ambegaon"],
["Online Bus Booking Ambegaon", "Event Bus Ambegaon"],
["Ambegaon Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Ambegaon Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Ambegaon Pune, ideal for family outings, group trips, school tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Ambegaon Pune and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Ambegaon Pune routes, ensuring safe, timely, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Ambegaon Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Ambegaon Pune."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Ambegaon Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Ambegaon Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Ambegaon Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Ambegaon Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Ambegaon Pune?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Ambegaon Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Ambegaon Pune routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Ambegaon Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Ambegaon Pune and nearby areas.'
  },
  {
    question: 'Is the bus service in Ambegaon Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Ambegaon Pune to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Ambegaon Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Milind Shinde',
    feedback: 'We rented a bus in Ambegaon Pune from Sanavi Travels — fantastic service and very comfortable bus!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Supriya Patil',
    feedback: 'Sanavi Travels provided a reliable and clean bus for our Ambegaon Pune trip. Highly recommended!',
    rating: 5
  }
];




























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusOrCoach",
  "name": "Bus On Rent in Ambegaon Pune - Sanavi Travels",
  "description": "Sanavi Travels offers buses on rent in Ambegaon Pune for weddings, corporate trips, tourist travel, and outstation journeys. AC, luxury, and chauffeur-driven buses available. Book online now.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Bus On Rent in Ambegaon Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC, luxury, wedding, corporate, and outstation buses in Ambegaon Pune with Sanavi Travels. Affordable, chauffeur-driven buses for group travel. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/149.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinambegaonpune;